import {
  PersonOutlineSmallIcon,
  TextCaption,
  TextLabel,
  token,
  Tooltip,
} from '@angeplus/prever-component-lib';
import { PlanVersion } from '../admin/plan-versions/plan-version.type';
import styled from '@emotion/styled';

type DependentRuleProps = { planVersion: PlanVersion };

export const DependentRule = (props: DependentRuleProps) => {
  const dependentGlobalsRules = props.planVersion?.dependent_rule?.globals;

  const selectedGlobalRule = dependentGlobalsRules?.find((data) => true);
  const hasDependentRule = !!selectedGlobalRule;
  const dependentsGlobalRulesQuantity = dependentGlobalsRules?.length;
  const minQuantity = selectedGlobalRule?.min_quantity_global;

  const withHolderAge =
    selectedGlobalRule?.holder_min_age &&
    `Possibilidade de contratação individual*`;
  const whithoutHolderAge =
    !selectedGlobalRule?.holder_min_age &&
    (minQuantity === 1
      ? `Necessário pelo menos ${minQuantity} dependente`
      : `Necessário pelo menos ${minQuantity} dependentes`);

  const message = withHolderAge || whithoutHolderAge;

  if (!hasDependentRule) {
    return <AlertRule message="Contratação individual disponível" />;
  }

  return (
    <AlertRule
      message={message}
      hasDetails={dependentsGlobalRulesQuantity >= 2}
      details={dependentGlobalsRules}
    />
  );
};

type AlertRuleProps = {
  message?: string;
  hasDetails?: boolean;
  details?: any;
};

const AlertRule = (props: AlertRuleProps) => {
  if (!props.message) return null;

  const details = formatDependentRuleLabel(props?.details);

  return (
    <Container>
      <PersonOutlineSmallIcon />
      <TextCaption>{props?.message}</TextCaption>
      {props?.hasDetails && (
        <Tooltip
          content={
            <TooltipContainer>
              <TextLabel>{props?.message}</TextLabel>
              <>
                {details?.map((data, i) => {
                  return <TextCaption key={i}>{data}</TextCaption>;
                })}
              </>
            </TooltipContainer>
          }
        />
      )}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  gap: ${token.spacing.spacingXxSmall};
  align-items: center;
`;

const TooltipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${token.spacing.spacingXxxSmall};
`;

const formatDependentRuleLabel = (data) => {
  return data
    ?.map((data) => {
      const label = [];

      if (data.holder_min_age && !data.min_quantity_global) return null;

      if (data.holder_min_age) {
        label.push(`Para titular a partir de ${data.holder_min_age} anos,`);
      } else {
        label.push(`Para outros casos`);
      }

      if (data.min_quantity_global === 0) {
        label.push(`contração individual disponível`);
      }
      if (data.min_quantity_global === 1) {
        label.push(`deve haver pelo menos um dependente`);
      }
      if (data.min_quantity_global > 1) {
        label.push(
          `deve haver pelo menos ${data.min_quantity_global} dependentes`,
        );
      }

      return label.join(' ');
    })
    ?.filter((data) => data);
};
